var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendationsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3538",
    "data-name": "Groupe 3538",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.295,
    height: 18.083,
    viewBox: "0 0 14.295 18.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2011",
    "data-name": "Trac\\xE9 2011",
    d: "M-291.895,2717.028a1.511,1.511,0,0,0,1.511,1.511,1.511,1.511,0,0,0,1.511-1.511,6.772,6.772,0,0,0-5.175-6.666,6.682,6.682,0,0,0-5.646,1.308,6.629,6.629,0,0,0-2.487,5.185v9.919a1.511,1.511,0,0,0,1.511,1.511,1.511,1.511,0,0,0,1.511-1.511v-9.919a3.621,3.621,0,0,1,1.36-2.831,3.673,3.673,0,0,1,3.106-.709A3.735,3.735,0,0,1-291.895,2717.028Z",
    transform: "translate(302.181 -2710.202)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2012",
    "data-name": "Trac\\xE9 2012",
    d: "M-261.709,2767.831l-4.553-4.429a1.511,1.511,0,0,0-2.137.03,1.511,1.511,0,0,0,.029,2.136l4.553,4.429a1.506,1.506,0,0,0,1.053.428,1.506,1.506,0,0,0,1.083-.458A1.511,1.511,0,0,0-261.709,2767.831Z",
    transform: "translate(275.546 -2752.342)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsWhiteIcon);
export default __webpack_public_path__ + "static/media/recommendationsWhiteIcon.bb9c4828288e62537b8b851411ef7092.svg";
export { ForwardRef as ReactComponent };